<div class="container-fluid">
  <div class="">
    <div class="row">
      <div
        class="row m-0 justify-content-start move-scroll horizontal-moves"
        #moveScrollContainerHorizontal
      >
        <div
          *ngFor="let item of moves; let i = index"
          class="col-6 move-one-section p-0 mb-0 mt-1"
        >
          <div class="d-flex align-items-center">
            <span *ngIf="i % 2 === 0" class="font mb-1 ms-2 numbers"
              >{{ i / 2 + 1 }}.</span
            >
            <p
              class="mb-1 move-box-border"
              (click)="gameData?.status === 'completed' && getMove(i)"
              [ngClass]="{ 'selected-move': i + 1 === currentIndex }"
            >
              {{ item }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-8 chessboard-col mt-3">
        <div class="main-chessBoard-box">
          <div class="player-info player-info-side">
            <div class="player-side-box">
              @if(gameData?.status !== 'completed'){ @if(loginUserId?.username
              == gameData?.whiteSidePlayer){
              <div class="d-flex align-items-center">
                <img
                  class="player-Img-size"
                  [src]="[
                    gameData?.blackSidePlayerImage
                      ? gameData.blackSidePlayerImage
                      : '/assets/customer-image/men-shadow.png'
                  ]"
                  alt="profile picture"
                />
                <div class="ms-2 player-text">
                  <div class="d-flex align-items-center flex-wrap">
                    <h2 class="player-text-color mb-0">
                      {{ gameData?.blackSidePlayer }}
                    </h2>
                    <p class="player-text-color mb-0 ms-2">
                      ({{ blackUpdateRating }}) @if(gameData?.ratedGame){
                      {{ blackDetailsRating }}
                      }
                    </p>
                  </div>
                  <div class="captured-main-section">
                    @for (item of getFormattedPiecesList(
                    eliminatedWhitePiecesCount ); track $index) {
                    <div class="captured-piece me-1">{{ item }}</div>
                    }
                  </div>
                </div>
              </div>
              } @else if(loginUserId?.username == gameData?.blackSidePlayer){
              <div class="d-flex align-items-center">
                <div class="d-flex">
                  <img
                    class="player-Img-size"
                    [src]="[
                      gameData?.whiteSidePlayerImage
                        ? gameData.whiteSidePlayerImage
                        : '/assets/customer-image/men-shadow.png'
                    ]"
                    alt="profile picture"
                  />

                  <div class="ms-2 player-text">
                    <div class="d-flex align-items-center flex-wrap">
                      <h2 class="player-text-color mb-0">
                        {{ gameData?.whiteSidePlayer }}
                      </h2>
                      <p class="player-text-color mb-0 ms-2">
                        ({{ whiteUpdateRating }}) @if(gameData?.ratedGame){
                        {{ whiteDetailsRating }}
                        }
                      </p>
                    </div>
                    <div class="captured-main-section">
                      @for (item of
                      getFormattedPiecesList(eliminatedBlackPiecesCount); track
                      $index) {
                      <div class="captured-piece me-1">{{ item }}</div>
                      }
                    </div>
                  </div>
                </div>
              </div>
              } @else {
              <div class="d-flex align-items-center">
                <div class="d-flex">
                  <img
                    class="player-Img-size"
                    [src]="[
                      gameData?.blackSidePlayerImage
                        ? gameData.blackSidePlayerImage
                        : '/assets/customer-image/men-shadow.png'
                    ]"
                    alt="profile picture"
                  />
                  <div class="ms-2 player-text">
                    <div class="d-flex align-items-center flex-wrap">
                      <h2 class="player-text-color mb-0">
                        {{ gameData?.blackSidePlayer }}
                      </h2>
                      <p class="player-text-color mb-0 ms-2">
                        ({{ blackUpdateRating }}) @if(gameData?.ratedGame){
                        {{ blackDetailsRating }}
                        }
                      </p>
                    </div>
                    <div class="captured-main-section">
                      @for (item of
                      getFormattedPiecesList(eliminatedWhitePiecesCount); track
                      $index) {
                      <div class="captured-piece me-1">{{ item }}</div>
                      }
                    </div>
                  </div>
                </div>
              </div>
              } @if(loginUserId?.username == gameData?.blackSidePlayer){
              <p
                class="mb-0 mt-1 timer"
                id="whiteSideTimer"
                [ngClass]="{ 'critical-time': isCriticalTime('white') }"
              >
                {{ whiteSideTimer }}
              </p>
              }@else if (loginUserId?.username === gameData?.whiteSidePlayer) {
              <p
                class="mb-0 mt-1 timer"
                id="blackSideTimer"
                [ngClass]="{ 'critical-time': isCriticalTime('black') }"
              >
                {{ blackSideTimer }}
              </p>
              }@else {
              <p
                class="mb-0 mt-1 timer"
                id="blackSideTimer"
                [ngClass]="{ 'critical-time': isCriticalTime('black') }"
              >
                {{ blackSideTimer }}
              </p>
              }
              <!-- <p class="mb-0 mt-1 timer" [ngClass]="{
                'low-time': (loginUserId?.username === gameData?.whiteSidePlayer && whiteCurrentTime < 60) || (loginUserId?.username === gameData?.blackSidePlayer && blackCurrentTime < 60),
                'critical-time': isCriticalTime()
              }" id="{{ loginUserId?.username == gameData?.blackSidePlayer ? 'whiteSideTimer' : 'blackSideTimer' }}">
                {{ loginUserId?.username == gameData?.blackSidePlayer ? whiteSideTimer : blackSideTimer }}
              </p> -->
              } @if(gameData?.status == 'completed'){
              <div class="d-flex align-items-center">
                <img
                  class="player-Img-size"
                  [src]="
                    isFlipped
                      ? gameData?.whiteSidePlayerImage
                        ? gameData.whiteSidePlayerImage
                        : '/assets/customer-image/men-shadow.png'
                      : gameData?.blackSidePlayerImage
                      ? gameData.blackSidePlayerImage
                      : '/assets/customer-image/men-shadow.png'
                  "
                  alt="profile picture"
                />
                <div class="ms-2 text-start">
                  <h5 class="player-text-color mb-0">
                    {{
                      isFlipped
                        ? gameData?.whiteSidePlayer
                        : gameData?.blackSidePlayer
                    }}
                    ({{ isFlipped ? whiteUpdateRating : blackUpdateRating }})
                  </h5>
                  <div class="d-flex captured-main-section">
                    @for (item of getFormattedPiecesList(isFlipped ?
                    eliminatedBlackPiecesCount : eliminatedWhitePiecesCount);
                    track $index) {
                    <div class="captured-piece me-1">{{ item }}</div>
                    }
                  </div>
                </div>
              </div>

              }
            </div>
          </div>

          <div class="Main-chessBoard">
            <div #boardContainer id="hijk"></div>
            <canvas id="arrowCanvas"></canvas>
          </div>

          <div class="player-info player-info-bottom">
            <div class="player-side-box">
              @if(gameData?.status !== 'completed'){ @if(loginUserId?.username
              == gameData?.blackSidePlayer){
              <div class="d-flex align-items-center">
                <img
                  class="player-Img-size"
                  [src]="[
                    gameData?.blackSidePlayerImage
                      ? gameData.blackSidePlayerImage
                      : '/assets/customer-image/men-shadow.png'
                  ]"
                  alt="profile picture"
                />
                <div class="ms-2 player-text">
                  <div class="d-flex align-items-center flex-wrap">
                    <h2 class="player-text-color mb-0">
                      {{ gameData?.blackSidePlayer }}
                    </h2>
                    <p class="player-text-color mb-0 ms-2">
                      ({{ blackUpdateRating }}) @if(gameData?.ratedGame){
                      {{ blackDetailsRating }}
                      }
                    </p>
                  </div>

                  <div class="captured-main-section">
                    @for (item of getFormattedPiecesList(
                    eliminatedWhitePiecesCount ); track $index) {
                    <div class="captured-piece me-1">{{ item }}</div>
                    }
                  </div>
                </div>
              </div>
              }@else if(loginUserId?.username == gameData?.whiteSidePlayer){
              <div class="d-flex align-items-center">
                <img
                  class="player-Img-size"
                  [src]="[
                    gameData?.whiteSidePlayerImage
                      ? gameData.whiteSidePlayerImage
                      : '/assets/customer-image/men-shadow.png'
                  ]"
                  alt="profile picture"
                />
                <div class="ms-2 player-text">
                  <div class="d-flex align-items-center flex-wrap">
                    <h2 class="player-text-color mb-0">
                      {{ gameData?.whiteSidePlayer }}
                    </h2>
                    <p class="player-text-color mb-0 ms-2">
                      ({{ whiteUpdateRating }}) @if(gameData?.ratedGame){
                      {{ whiteDetailsRating }}
                      }
                    </p>
                  </div>

                  <div class="captured-main-section">
                    @for (item of
                    getFormattedPiecesList(eliminatedBlackPiecesCount); track
                    $index) {
                    <div class="captured-piece me-1">{{ item }}</div>
                    }
                  </div>
                </div>
              </div>
              }@else {
              <div class="d-flex align-items-center">
                <img
                  class="player-Img-size"
                  [src]="[
                    gameData?.whiteSidePlayerImage
                      ? gameData.whiteSidePlayerImage
                      : '/assets/customer-image/men-shadow.png'
                  ]"
                  alt="profile picture"
                />
                <div class="ms-2 player-text">
                  <div class="d-flex align-items-center flex-wrap">
                    <h2 class="player-text-color mb-0">
                      {{ gameData?.whiteSidePlayer }}
                    </h2>
                    <p class="player-text-color mb-0 ms-2">
                      ({{ whiteUpdateRating }}) @if(gameData?.ratedGame){
                      {{ whiteDetailsRating }}
                      }
                    </p>
                  </div>

                  <div class="captured-main-section">
                    @for (item of
                    getFormattedPiecesList(eliminatedBlackPiecesCount); track
                    $index) {
                    <div class="captured-piece me-1">{{ item }}</div>
                    }
                  </div>
                </div>
              </div>
              }
              <!-- <p class="mb-0 mt-1 timer"
                id="{{ loginUserId?.username == gameData?.blackSidePlayer ? 'blackSideTimer' : 'whiteSideTimer' }}"
                [ngClass]="{
                  'critical-time': isCriticalTime(),
              }">
                {{ loginUserId?.username == gameData?.blackSidePlayer ? blackSideTimer : whiteSideTimer }}
              </p> -->
              @if(loginUserId?.username == gameData?.blackSidePlayer){
              <p
                class="mb-0 mt-1 timer"
                id="blackSideTimer"
                [ngClass]="{ 'critical-time': isCriticalTime('black') }"
              >
                {{ blackSideTimer }}
              </p>
              }@else if (loginUserId?.username === gameData?.whiteSidePlayer) {
              <p
                class="mb-0 mt-1 timer"
                id="whiteSideTimer"
                [ngClass]="{ 'critical-time': isCriticalTime('white') }"
              >
                {{ whiteSideTimer }}
              </p>
              }@else {
              <p
                class="mb-0 mt-1 timer"
                id="whiteSideTimer"
                [ngClass]="{ 'critical-time': isCriticalTime('white') }"
              >
                {{ whiteSideTimer }}
              </p>
              } }@if(gameData?.status == 'completed'){
              <div class="d-flex align-items-center">
                <img
                  class="player-Img-size"
                  [src]="
                    isFlipped
                      ? gameData?.blackSidePlayerImage
                        ? gameData.blackSidePlayerImage
                        : '/assets/customer-image/men-shadow.png'
                      : gameData?.whiteSidePlayerImage
                      ? gameData.whiteSidePlayerImage
                      : '/assets/customer-image/men-shadow.png'
                  "
                  alt="profile picture"
                />

                <div class="ms-2 text-start">
                  <h5 class="player-text-color mb-0">
                    {{
                      isFlipped
                        ? gameData?.blackSidePlayer
                        : gameData?.whiteSidePlayer
                    }}
                    ({{ isFlipped ? blackUpdateRating : whiteUpdateRating }})
                  </h5>
                  <div class="d-flex captured-main-section">
                    @for (item of getFormattedPiecesList(isFlipped ?
                    eliminatedWhitePiecesCount : eliminatedBlackPiecesCount);
                    track $index) {
                    <div class="captured-piece me-1">{{ item }}</div>
                    }
                  </div>
                </div>
              </div>

              }
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 p-0 playerMove">
        <div
          class="d-flex align-items-center justify-content-center game-main-heading p-3"
        >
          <img [src]="boardModeimg" class="me-2" alt="" />
          <h3 class="m-0">
            {{ gameData?.gameMode
            }}<span class="gameMode-time">({{ gameData?.time }})</span>
          </h3>
        </div>
        <div class="mb-2 px-2">
          <p class="font">
            Date -
            <span class="text">{{ gameData?.date | date : "fullDate" }}</span>
          </p>

          @if(gameData?.wonBY){
          <p class="font">
            Result -
            <span class="text"
              >{{ gameData?.wonBY }}
              @if(gameData?.ratedGame){ (Rated) }
            </span>
          </p>
          }
        </div>

        <div class="p-3 game-main-move">
          <h4 class="m-0">Moves</h4>
          <hr style="color: #ffff" />
          <div class="">
            <div
              class="row mx-2 px-1 move-scroll justify-content-start vertical-moves"
              #moveScrollContainerVertical
            >
              <div
                *ngFor="let item of moves; let i = index"
                class="col-6 move-one-section p-0 mb-0"
              >
                <div class="d-flex align-items-center">
                  <span *ngIf="i % 2 === 0" class="font mb-1 mx-2 numbers"
                    >{{ i / 2 + 1 }}.</span
                  >
                  <p
                    class="mb-0 move-box-border"
                    (click)="gameData?.status === 'completed' && getMove(i)"
                    [ngClass]="{ 'selected-move': i + 1 === currentIndex }"
                    [innerHTML]="item | pieceIcon"
                  >
                    {{ item }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        @if(loginUserId?.username === gameData?.whiteSidePlayer ||
        loginUserId?.username === gameData?.blackSidePlayer){ @if(completeDraw){
        <h4 id="gamecontinue" class="modal-title text-center mt-0 m-1">
          Draw Request Denied.
        </h4>
        } }

        <div class="p-2">
          @if(gameData?.status == 'completed'){
          <div class="game-btn-mode my-4">
            <button
              class="btn move-button rounded"
              (click)="resetChessBoard()"
              (keydown)="onKeyDown($event)"
            >
              <i
                class="fa-solid fa-backward-step"
                style="color: var(--default-font-color)"
              ></i>
            </button>
            <button
              class="btn move-button rounded"
              (click)="prevMove()"
              (keydown)="onKeyDown($event)"
            >
              <i
                class="fa-solid fa-angle-left"
                style="color: var(--default-font-color)"
              ></i>
            </button>
            <button
              class="btn move-button rounded"
              (click)="nextMove()"
              (keydown)="onKeyDown($event)"
            >
              <i
                class="fa-solid fa-angle-right"
                style="color: var(--default-font-color)"
              ></i>
            </button>
            <button class="btn move-button rounded" (click)="endChessBoard()">
              <i
                class="fa-solid fa-forward-step"
                style="color: var(--default-font-color)"
              ></i>
            </button>
            <button
              class="btn move-button rounded"
              (click)="filpChessBoard()"
              (keydown)="onKeyDown($event)"
            >
              <i
                class="fa-solid fa-repeat"
                style="color: var(--default-font-color)"
              ></i>
            </button>
          </div>
          } @if (loginUserId?.username == gameData?.whiteSidePlayer ||
          loginUserId?.username == gameData?.blackSidePlayer) { @if(drawbtn){
          <div class="d-flex justify-content-between mx-3">
            <button class="btn game-deside-btn" (click)="drawGame()">
              1/2 Draw
            </button>
            <button class="btn game-deside-btn" (click)="resignGame()">
              Resign
            </button>
          </div>
          }@else if (!drawbtn && gameData?.status !== 'completed' && !checkmate)
          {
          <button class="btn game-abort-btn" (click)="abortGame()">
            Abort
          </button>
          } } @if(newMatchMakingGame){
          <button class="btn game-abort-btn" (click)="abortGame()">
            NewGame
          </button>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: displayStyle2 }"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="d-flex justify-content-end px-2">
          <i class="fa-solid close-icon fa-xmark" (click)="closegameOver()"></i>
        </div>
        <h4 class="modal-title text-center mb-2">
          {{
            winnerPlayer
              ? winnerPlayer + " Won"
              : isAborted
              ? "Aborted"
              : "Draw"
          }}
        </h4>
        <div
          class="players d-flex justify-content-around align-items-center mt-3"
        >
          <div class="player">
            @if(gameData?.blackSidePlayerImage){
            <img
              class="player-popupImg-size"
              [ngClass]="{
                'winner-User': winnerPlayer === gameData?.blackSidePlayer
              }"
              [src]="[gameData?.blackSidePlayerImage]"
              alt="profile picture"
            />
            } @else {
            <img
              class="player-popupImg-size"
              [ngClass]="{
                'winner-User': winnerPlayer === gameData?.blackSidePlayer
              }"
              src="/assets/customer-image/men-shadow.png"
              alt=""
            />
            }
            <p class="player-name m-0">{{ gameData?.blackSidePlayer }}</p>
          </div>

          <div class="vs-type">
            <p class="vs-text m-0">vs</p>
          </div>

          <div class="player">
            @if(gameData?.whiteSidePlayerImage){
            <img
              class="player-popupImg-size"
              [ngClass]="{
                'winner-User': winnerPlayer === gameData?.whiteSidePlayer
              }"
              [src]="[gameData?.whiteSidePlayerImage]"
              alt="profile picture"
            />
            } @else {
            <img
              class="player-popupImg-size"
              [ngClass]="{
                'winner-User': winnerPlayer === gameData?.whiteSidePlayer
              }"
              src="/assets/customer-image/men-shadow.png"
              alt=""
            />
            }
            <p class="player-name m-0">{{ gameData?.whiteSidePlayer }}</p>
          </div>
        </div>
        @if(gameData?.whiteSidePlayer == loginUserId?.username ||
        gameData?.blackSidePlayer == loginUserId?.username){

        <button
          class="btn w-100 rematch-btn"
          (click)="rematchReqeust(loginUserId.username)"
          [disabled]="loadingrematch"
        >
          {{ loadingrematch ? "Loading..." : "Rematch" }}
        </button>

        <div class="match-denied text-center">
          <p class="player-name mt-3 m-0">{{ remacthDenied }}</p>
        </div>
        }
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: ConfirmResignation }"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body pb-0">
        <h5 class="mb-0 text-center">Are you sure you want to resign?</h5>
      </div>
      <div class="modal-footer border-0 justify-content-center">
        <button
          type="button"
          class="btn rematch-btn"
          (click)="confirmresignClose()"
        >
          Cancel
        </button>
        <button type="button" class="btn btn-danger" (click)="confirmResign()">
          Resign
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal isDraw-mobile-popup"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: isDrawPopup }"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body pb-0">
        <h5 class="mb-0 text-center">
          Your opponent has offered a draw. Do you accept?
        </h5>
      </div>
      <div class="modal-footer border-0 justify-content-center">
        <button
          type="button"
          class="btn btn-success"
          (click)="drawAccess('true')"
        >
          Accept
        </button>
        <button
          type="button"
          class="btn btn-danger"
          (click)="drawReject('false')"
        >
          Reject
        </button>
      </div>
    </div>
  </div>
</div>

@if(gameData?.status !== 'completed'){ @if(showAnimation){
<div class="game-start-animation" [@fadeInOut]>
  <div class="player-section">
    <img [src]="player1Image" alt="Player 1" class="player-image" />
    <div>{{ player1Name }}</div>
  </div>
  <div class="vs">VS</div>
  <div class="player-section">
    <img [src]="player2Image" alt="Player 2" class="player-image" />
    <div>{{ player2Name }}</div>
  </div>
</div>

} }
